module.exports = __webpack_public_path__ + "img/photo-58.15de8ddd.jpg";